import { render, staticRenderFns } from "./teaching_data_tab.vue?vue&type=template&id=18277492&scoped=true"
import script from "./teaching_data_tab.vue?vue&type=script&lang=js"
export * from "./teaching_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18277492",
  null
  
)

export default component.exports